import { Icon, Text, ToastType, theme, useToastsDispatch } from '@bechtel/gds';
import { useLanguage } from '~/components';

interface UseToastProps {
  showToast: (toastText, arrayMessage?: string[], toastType?: ToastType) => void;
}

export const useToast: () => UseToastProps = () => {
  const dispatch = useToastsDispatch();
  const { getMultiLingualTextByKey } = useLanguage();

  const showToast = (toastText, arrayMessage: string[] = [''], toastType: ToastType = ToastType.INFO) => {
    const successIcon = (
      <Icon icon="circle-check" fillColor="green.300" iconStyle="solid" style={{ marginRight: theme.spacings[450] }} />
    );
    const errorIcon = <Icon icon="circle-xmark" fillColor="red.200" style={{ marginRight: theme.spacings[450] }} />;
    const successToast = {
      type: 'ADD_TOAST',
      payload: {
        toastType: toastType === ToastType.INFO ? ToastType.INFO : ToastType.WARNING,
        content: () => (
          <>
            {toastType === ToastType.INFO ? successIcon : errorIcon}
            <Text color="white" size="400" weight="600">
              {getMultiLingualTextByKey(toastText, arrayMessage)}
            </Text>
          </>
        ),
        autoDismissTimeout: 2500,
      },
    };
    dispatch(successToast);
  };

  return {
    showToast,
  };
};
